import { createContext, useContext } from "react";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import type { SlotProviderProps, SlotContext } from "@b2bportal/core-utilities";
import {
  FlightFareGridItem,
  FlightShopSearch,
  FlightShopBreadcrumbs,
  FlightListNoFlights,
  FlightCardFareList,
  FlightCardFareListItem,
  ReviewFlightHeader,
  ReviewFlightSecondaryContent,
  FlightCard,
  FilterDialog,
} from "@tenant/flights";

export const defaultFlightSlots = () => ({
  [CoreFlightsComponent.FlightFareGridItem]: FlightFareGridItem,
  [CoreFlightsComponent.FlightShopSearch]: FlightShopSearch,
  [CoreFlightsComponent.FlightShopBreadcrumbs]: FlightShopBreadcrumbs,
  [CoreFlightsComponent.FlightListNoFlights]: FlightListNoFlights,
  [CoreFlightsComponent.FlightCardFareList]: FlightCardFareList,
  [CoreFlightsComponent.FlightCardFareListItem]: FlightCardFareListItem,
  [CoreFlightsComponent.ReviewFlightHeader]: ReviewFlightHeader,
  [CoreFlightsComponent.ReviewFlightSecondaryContent]:
    ReviewFlightSecondaryContent,
  [CoreFlightsComponent.FlightCard]: FlightCard,
  [CoreFlightsComponent.FilterDialog]: FilterDialog,
});

export type FlightSlotType = ReturnType<typeof defaultFlightSlots>;

const FlightSlotContext = createContext<
  SlotContext<FlightSlotType> | undefined
>(undefined);

export const FlightSlotProvider = ({
  context,
  children,
}: SlotProviderProps<FlightSlotType>) => {
  return (
    <FlightSlotContext.Provider value={context}>
      {children}
    </FlightSlotContext.Provider>
  );
};

const useSlotSystem = () => {
  const context = useContext(FlightSlotContext);
  if (context == null) {
    throw new Error("useSlots must be used within a FlightSlotProvider");
  }
  return context;
};

export const useFlightSlot = () => {
  const context = useSlotSystem();
  return context.components;
};
